<template>
  <div
    class="InfoColorUpReview"
    :class="{ 'is-pdf': formatPdf }"
    v-images-loaded:on.progress="imageProgress"
  >
    <div class="card card-light mt-5">
      <div class="card-body p-0">
        <h5 class="card-title font-weight-normal mb-2">
          CONSTRUCTION MATERIALS
        </h5>

        <div class="card-content">
          <template v-for="variable in convertToVariableListByWeight">
            <!-- Cuts -->
            <div
              v-if="variable.varType === 'VariableCut'"
              class="card-row d-flex justify-content-between"
              :key="variable._id"
            >
              <b class="label">{{ variable.name }}</b>
              <span>{{ variable.selectedOptionName }}</span>
            </div>
            <!-- Generics -->
            <div
              v-if="variable.varType === 'VariableGeneric'"
              class="card-row d-flex justify-content-between"
              :key="variable._id"
            >
              <b class="label">{{ variable.name }}</b>
              <span>{{ variable.optionName }}</span>
            </div>
            <!-- Fabrics -->
            <div
              v-if="variable.varType === 'VariableFabric'"
              :key="variable._id"
            >
              <div
                class="card-row d-flex justify-content-between"
                :class="{
                  'flex-wrap': variable.noteText && variable.noteText !== ''
                }"
              >
                <b class="label">{{ variable.name }}: Fabric</b>
                <span>{{ variable.selectedOptionName }}</span>
                <div
                  class="noteText"
                  v-if="variable.noteText && variable.noteText !== ''"
                  v-html="variable.noteText"
                ></div>
              </div>
              <div
                v-if="colorSelected(variable.selectedColors)"
                class="card-row d-flex justify-content-between"
              >
                <b class="label">{{ variable.name }}: Color</b>
                <span>{{ colorSelected(variable.selectedColors) }}</span>
              </div>
            </div>
            <!-- Colors -->
            <div
              v-if="variable.varType === 'VariableColor'"
              class="card-row d-flex justify-content-between"
              :key="variable._id"
            >
              <b class="label">{{ variable.name }}</b>
              <span>{{ colorSelected(variable.selectedColors) }}</span>
            </div>
            <!-- Patterns -->
            <template v-if="variable.varType === 'VariablePattern'">
              <div
                v-for="pattern in variable.patterns"
                class="card-row d-flex justify-content-between"
                :key="pattern._id"
              >
                <b class="label">{{ pattern.name }}</b>
                <span>{{ pattern.optName }}</span>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>

    <div v-if="hasDecorations" class="decorations card card-light mt-5">
      <div class="card-body p-0">
        <h5 class="card-title font-weight-normal mb-0">
          DECORATIONS
        </h5>

        <div class="row">
          <div
            class="col-md-6 mt-3 mb-3"
            v-for="variable in textVariables"
            :key="variable._id"
          >
            <div class="card-content">
              <h6 class="card-row-title text-uppercase">
                {{ variable.name }}
              </h6>

              <div
                v-if="
                  variable.imagesData &&
                    variable.imagesData.find(x => x.type === 'main') &&
                    variable.imagesData.find(x => x.type === 'main').image
                "
                class="card-row d-flex justify-content-between"
              >
                <BBSectionLoader
                  v-if="thumbsRefreshing && !getterLoaderVisible"
                  :is-loading="true"
                />
                <div
                  v-if="!thumbsRefreshing"
                  class="text-image image-var mb-2 w-100 text-center p-1"
                  :style="'backgroundColor:' + bodyColor + ';'"
                >
                  <a
                    :href="
                      variable.imagesData.find(x => x.type === 'main').image.src
                    "
                    target="_blank"
                  >
                    <img
                      class="img-fluid"
                      :src="
                        variable.imagesData.find(x => x.type === 'main').image
                          .src +
                          '?r=' +
                          sufixImages
                      "
                      alt=""
                    />
                  </a>
                </div>
              </div>

              <div
                class="card-row d-flex justify-content-between"
                v-if="variable.textType === _get(getterTextTypeTeamName, '_id')"
              >
                <b class="label">Text</b>
                <span>{{ variable.typedTextName }}</span>
              </div>

              <div class="card-row d-flex justify-content-between">
                <b class="label">Material</b>
                <span>{{
                  stateMaterials &&
                    stateMaterials.find(
                      x => x._id === variable.selectedMaterialId
                    ) &&
                    stateMaterials.find(
                      x => x._id === variable.selectedMaterialId
                    ).name
                }}</span>
              </div>

              <div class="card-row d-flex justify-content-between">
                <b class="label">Font</b>
                <span>{{ variable.selectedFontName }}</span>
              </div>

              <div
                v-if="variable.textType !== _get(getterTextTypeTeamName, '_id')"
                class="card-row d-flex justify-content-between"
              >
                <b class="label" v-if="variable.placementName"
                  >{{ variable.placementName.toLowerCase() }} height</b
                >
                <b v-else>height</b>
                <span>{{ variable.selectedHeightOption }}</span>
              </div>

              <div
                v-if="
                  variable.imagesData &&
                    variable.imagesData.find(x => x.type === 'main')
                "
                class="card-row d-flex justify-content-between"
              >
                <b class="label">Size</b>
                <span>
                  {{
                    variable.imagesData.find(x => x.type === 'main').image
                      .height
                  }}
                  h x
                  {{
                    variable.imagesData.find(x => x.type === 'main').image.width
                  }}
                  w</span
                >
              </div>

              <template v-if="variable.selectedSecondHeightOption">
                <div
                  v-if="
                    variable.imagesData &&
                      variable.imagesData.find(x => x.type === 'second') &&
                      variable.imagesData.find(x => x.type === 'second').image
                  "
                  class="card-row d-flex justify-content-between"
                >
                  <BBSectionLoader
                    v-if="thumbsRefreshing && !getterLoaderVisible"
                    :is-loading="true"
                  />

                  <div
                    v-if="!thumbsRefreshing"
                    class="text-image image-var mt-4 mb-2 w-100 text-center p-1"
                    :style="'backgroundColor:' + bodyColor + ';'"
                  >
                    <a
                      :href="
                        variable.imagesData.find(x => x.type === 'second').image
                          .src
                      "
                      target="_blank"
                    >
                      <img
                        class="img-fluid"
                        :src="
                          variable.imagesData.find(x => x.type === 'second')
                            .image.src
                        "
                        alt=""
                      />
                    </a>
                  </div>
                </div>

                <div
                  v-if="
                    variable.textType !== _get(getterTextTypeTeamName, '_id')
                  "
                  class="card-row d-flex justify-content-between"
                >
                  <b class="label" v-if="variable.secondPlacementName"
                    >{{ variable.secondPlacementName.toLowerCase() }} height</b
                  >
                  <b v-else>height</b>
                  <span>{{ variable.selectedSecondHeightOption }}</span>
                </div>

                <div
                  class="card-row d-flex justify-content-between"
                  v-if="
                    variable.imagesData &&
                      variable.imagesData.find(x => x.type === 'second')
                  "
                >
                  <b class="label">Size</b>
                  <span>
                    {{
                      variable.imagesData.find(x => x.type === 'second').image
                        .height
                    }}
                    h x
                    {{
                      variable.imagesData.find(x => x.type === 'second').image
                        .width
                    }}
                    w</span
                  >
                </div>
              </template>

              <div class="card-row d-flex justify-content-between">
                <b class="label">Fill</b>
                <span>{{ colorSelected(variable.fillColors) }}</span>
              </div>
              <div
                v-if="variable.selectedOutline"
                class="card-row d-flex justify-content-between"
              >
                <b class="label">Outline</b>
                <span>{{ colorSelected(variable.outlineColors) }}</span>
              </div>
              <div
                v-if="variable.selectedArcStyleId"
                class="card-row d-flex justify-content-between"
              >
                <b class="label">Arc</b>
                <span>{{ variable.selectedArcStyleId }}</span>
              </div>
              <div
                v-else-if="
                  variable.textType === _get(getterTextTypeTeamName, '_id')
                "
                class="card-row d-flex justify-content-between"
              >
                <b class="label">Arc</b>
                <span>Straight</span>
              </div>
              <div
                v-if="variable.selectedTailStyleId"
                class="card-row d-flex justify-content-between"
              >
                <b class="label">Tail</b>
                <span>{{ variable.selectedTailStyleId }}</span>
              </div>
            </div>
          </div>

          <div
            class="col-md-6 mt-3 mb-3"
            v-for="variable in images"
            :key="variable.key"
          >
            <div class="card-content">
              <h6 class="card-row-title text-uppercase">
                {{ variable.name }}
              </h6>
              <div class="image-var mt-2 mb-2">
                <a
                  :href="variable.srcOriginal"
                  target="_blank"
                  title="Click to download"
                >
                  <img
                    class="img-fluid"
                    :data-key="variable.key"
                    :src="getImageBase64Src(variableImageUrl(variable.src))"
                    alt=""
                  />
                </a>
              </div>
              <div class="card-row d-flex justify-content-between">
                <b class="label">Material</b>
                <span>{{ variable.material }}</span>
              </div>
              <div class="card-row d-flex justify-content-between">
                <b class="label">Location</b>
                <span>{{ variable.location }}</span>
              </div>
              <div class="card-row d-flex justify-content-between">
                <b class="label">Size</b>
                <span class="text-lowercase">{{ variable.size }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
// import ProductView from '@/views/frontend/ProductView'
import { groupBy as _groupBy, map as _map, flatMap as _flatMap } from 'lodash'
import BBSectionLoader from '@/components/common/BBSectionLoader'

@Component({
  components: {
    BBSectionLoader
  }
})
export default class InfoColorUpReview extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => []
  })
  menuItems

  @Prop({
    type: Array,
    required: true,
    default: () => []
  })
  stateMaterials

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  formatPdf

  @Prop({
    type: String,
    required: true,
    default: ''
  })
  sufixImages

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  thumbsRefreshing

  thumbsLoaded = {}

  imageProgress(instance, image) {
    const result = image.isLoaded ? 'loaded' : 'broken'

    if (image.isLoaded) {
      const key = this._get(image, 'img.dataset.key')
      this.thumbsLoaded[key] = true
    }

    if (this.images.some(item => !this.thumbsLoaded[item.key]) === false) {
      this.$emit('onThumbsLoaded')
    }
  }

  @Watch('images', { immediate: true })
  onImages(newValue) {
    if (Array.isArray(newValue) && newValue.length === 0) {
      this.$emit('onThumbsLoaded')
    }
  }

  get variables() {
    let variables = []

    this.menuItems &&
      this.menuItems.length > 0 &&
      this.menuItems
        .sort((a, b) => {
          return a.weight - b.weight
        })
        .forEach(item => {
          item.variableList.forEach(variable => {
            variables.push(variable)
          })
        })

    return _groupBy(variables, 'varType')
  }

  get convertToVariableListByWeight() {
    let variables = []

    this.menuItems &&
      this.menuItems.length > 0 &&
      this.menuItems
        .sort((a, b) => {
          return a.weight - b.weight
        })
        .forEach(item => {
          item.variableList.forEach(variable => {
            if (variable.varType === 'VariablePattern') {
              variable.patterns = this.patternVariables.filter(
                x => x.variableId === variable._id
              )
            }

            variables.push(variable)
          })
        })

    return variables
  }

  variableImageUrl(imageSrc) {
    if (imageSrc.indexOf('http:') !== -1 || imageSrc.indexOf('https:') !== -1) {
      return imageSrc
    } else {
      return `/img/teamLogos/${imageSrc}`
    }
  }

  get textVariables() {
    return (
      this.variables &&
      Array.isArray(this.variables.VariableText) &&
      this.variables.VariableText.filter(
        variable => variable.isSelected === true
      )
    )
  }

  get hasDecorations() {
    return (
      (Array.isArray(this.textVariables) && this.textVariables.length > 0) ||
      (Array.isArray(this.images) && this.images.length > 0)
    )
  }

  get patternVariables() {
    const patternRows = []

    this.variables &&
      Array.isArray(this.variables.VariablePattern) &&
      this.variables.VariablePattern.forEach(variable => {
        variable.options.forEach(opt => {
          const patternStyle = opt.patternStyles.find(
            p => p.isSelected === true
          )
          if (
            patternStyle &&
            opt.name &&
            opt.name.toLowerCase() !== 'no pattern prints' &&
            opt.name.toLowerCase() !== 'none'
          ) {
            patternRows.push({
              variableId: variable._id,
              key: opt._id,
              name: variable.name,
              optName: opt.name,
              locations: ''
            })
          }
          let patternColors = []
          if (this._has(patternStyle, 'parentColorAreas')) {
            patternStyle.parentColorAreas.forEach((colorArea, idx) => {
              const selColor = colorArea.selectedColors.find(
                color => color.isSelected === true
              )
              patternColors.push({
                id: colorArea.id,
                label: selColor.name && selColor.name.trim()
              })
            })
            if (patternColors.length > 0) {
              patternRows.push({
                variableId: variable._id,
                key: patternColors.map(i => i.id).join('-'),
                name:
                  variable.name &&
                  `${variable.name.trim()} Color${
                    patternColors.length > 0 ? 's' : ''
                  }`,
                optName: patternColors.map(i => i.label).join(', '),
                locations: this.getLocationsPatternVar(variable._id)
              })
            }
          }
        })

        const locations = this.getLocationsPatternVar(variable._id)

        if (locations) {
          patternRows.push({
            variableId: variable._id,
            key: variable._id,
            name: variable.name && variable.name.trim(),
            optName: locations
          })
        }
      })

    return patternRows
  }

  getLocationsPatternVar(varId) {
    const locations = []

    _map(this.variables, variable => {
      variable.applyPatterns &&
        variable.applyPatterns.forEach(ap => {
          if (
            ap.isSelected === true &&
            ap.payload &&
            ap.payload.variableId === varId
          ) {
            locations.push(variable.name)
          }
        })
    })

    return locations.join()
  }

  get images() {
    const imageRows = []

    this.variables &&
      Array.isArray(this.variables.VariableImage) &&
      this.variables.VariableImage.forEach(variable => {
        variable.logos.forEach(logo => {
          logo.locations.forEach(location => {
            let logoMaterial = this.stateMaterials.find(
              x => x._id === location.imageData.material
            )
            imageRows.push({
              key: location._id,
              name: variable.name,
              src: logo.image && (logo.image.srcThumbnail || logo.image.src),
              srcOriginal:
                logo.image && (logo.image.srcOriginal || logo.image.src),
              location: location.name,
              material: logoMaterial && logoMaterial.name,
              size:
                location.imageData &&
                (location.imageData.logoWidth
                  ? `${location.imageData.logoHeight}" h x ${location.imageData.logoWidth}" w`
                  : `${location.imageData.height}" h x ${location.imageData.width}" w`)
            })
          })
        })
      })

    return imageRows
  }

  get bodyColor() {
    const productId = this.menuItems[0].belongsToProductId
    const bodyColorObj = this.getBodyColorSelected(productId)
    if (bodyColorObj) {
      const colorObj = this.allAvailableColors.find(
        x => x._id === bodyColorObj.id
      )
      return `#${colorObj.option.value}`
    }
    return 'transparent'
  }

  colorSelected(opts) {
    const opt =
      Array.isArray(opts) && opts.find(item => item.isSelected === true)

    return opt && opt.name
  }
}
</script>

<style lang="scss" scoped>
.InfoColorUpReview {
  .image-var {
    padding: 0.5rem 0.5rem;
    text-align: center;

    img {
      height: 70px;
    }
  }
  .text-image {
    img {
      height: auto !important;
    }
  }

  .card-row-title {
    color: $base-black-color;
    font-size: 0.875rem;
    font-weight: bold;
    margin-bottom: 0;
  }

  /* .decorations {
    .card-row {
      @include media-breakpoint-up(xl) {
        font-size: 0.8225rem;
      }
    }
  } */

  .card-row {
    font-size: 0.8225rem;
    text-transform: capitalize;

    @include media-breakpoint-up(xl) {
      font-size: 0.9225rem;
    }

    .label {
      font-size: 0.975rem;
      text-transform: capitalize;
    }

    *:last-child {
      text-align: right;
    }

    .noteText {
      flex: 0 0 100%;
      max-width: 100%;
      width: 100%;
      text-align: left;
      /deep/ p {
        margin-top: 3px;
        margin-bottom: 1px;
      }
    }
  }

  /* &.is-pdf {
    .card-row {
      font-size: 0.8225rem;
      text-transform: capitalize;

      @include media-breakpoint-up(xl) {
        font-size: 1.0225rem;
      }

      .label {
        font-size: 1.075rem;
      }
    }
  } */
}
</style>
